import React from 'react';
import { Box, useTheme } from '@mui/material';

export const ADMIN_MODE_BANNER_HEIGHT = 20;

/**
 * Fixed strip across the top of the screen while in admin mode. The page layout and side
 * nav are offset by ADMIN_MODE_BANNER_HEIGHT so nothing sits underneath it.
 */
export const AdminModeBanner = () => {
	const theme = useTheme();

	return (
		<Box
			role='status'
			sx={{
				position: 'fixed',
				top: 0,
				left: 0,
				right: 0,
				height: ADMIN_MODE_BANNER_HEIGHT,
				zIndex: theme.zIndex.drawer + 1,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				backgroundColor: theme.palette.warning.light,
				color: theme.palette.getContrastText(theme.palette.warning.main),
				fontSize: '0.7rem',
				fontWeight: 700,
				letterSpacing: '0.75em',
			}}
		>
			ADMIN MODE
		</Box>
	);
};
